/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDesignServicesIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-design-services"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.45 10.4L10.38 8.47L9.6 7.7L9.32 7.97Q8.95 8.35 8.4 8.35Q7.85 8.35 7.47 7.97Q7.1 7.6 7.1 7.05Q7.1 6.5 7.47 6.13L7.75 5.85L6.85 4.97L4.92 6.9ZM17.07 19.07L19 17.15L18.18 16.3L17.9 16.57Q17.52 16.95 16.98 16.95Q16.43 16.95 16.05 16.57Q15.68 16.2 15.68 15.65Q15.68 15.1 16.05 14.72L16.32 14.45L15.55 13.68L13.63 15.6ZM15.8 6.85L17.25 8.3L18.93 6.63L17.45 5.15ZM3.52 21.8Q2.98 21.8 2.59 21.41Q2.2 21.02 2.2 20.48L2.2 17.15Q2.2 16.88 2.3 16.64Q2.4 16.4 2.6 16.2L6.6 12.2L2.63 8.28Q2.05 7.7 2.05 6.86Q2.05 6.03 2.63 5.45L5.47 2.6Q6.05 2.02 6.88 2.02Q7.7 2.02 8.28 2.6L12.28 6.6L16.1 2.77Q16.4 2.48 16.76 2.34Q17.13 2.2 17.5 2.2Q17.88 2.2 18.26 2.34Q18.65 2.48 18.93 2.77L21.3 5.2Q21.57 5.5 21.73 5.86Q21.88 6.22 21.88 6.6Q21.88 6.97 21.71 7.35Q21.55 7.72 21.27 8L17.48 11.78L21.4 15.72Q21.98 16.3 21.98 17.13Q21.98 17.95 21.4 18.52L18.55 21.38Q17.98 21.95 17.14 21.95Q16.3 21.95 15.72 21.38L11.8 17.4L7.8 21.4Q7.6 21.6 7.36 21.7Q7.13 21.8 6.85 21.8Z" fill={color} />
    </svg>
  );
}
